export default "__VITE_ASSET__DZCc7C84__"